// JsFromRoutes CacheKey 27e8cf7d96ef2cca80b1e67da063fe80
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client";

export default {
  publish: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/program_pages/:id/publish",
  ),
  archive: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/program_pages/:id/archive",
  ),
  index: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/programs/:program_id/program_pages",
  ),
  create: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/programs/:program_id/program_pages",
  ),
  new: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/programs/:program_id/program_pages/new",
  ),
  edit: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/program_pages/:id/edit",
  ),
  show: /* #__PURE__ */ definePathHelper("get", "/admin/v2/program_pages/:id"),
  update: /* #__PURE__ */ definePathHelper(
    "patch",
    "/admin/v2/program_pages/:id",
  ),
  destroy: /* #__PURE__ */ definePathHelper(
    "delete",
    "/admin/v2/program_pages/:id",
  ),
};
